import { render, staticRenderFns } from "./layout-left.vue?vue&type=template&id=3471ad90&scoped=true&"
import script from "./layout-left.vue?vue&type=script&lang=js&"
export * from "./layout-left.vue?vue&type=script&lang=js&"
import style0 from "./layout-left.vue?vue&type=style&index=0&id=3471ad90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471ad90",
  null
  
)

export default component.exports